import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOdnoklassnikiComponent } from './simple-icons-odnoklassniki.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOdnoklassnikiComponent ],
    exports:      [ SimpleIconsOdnoklassnikiComponent ],
    bootstrap:    []
})
export class SimpleIconsOdnoklassnikiModule {}
